import React, { Component } from "react"
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Modal, Input, Form, Button } from '@drifthq/tide-core'
import PropTypes from "prop-types"
import InstallNotification from "components/OnboardingInstallNotification"
import { pathOr } from 'ramda'
import { isEmail } from 'validator'
import { api } from 'modules/org/api'

import { track } from 'utils/trackingUtils'

import * as OrgActions from 'modules/org/actions'

import './style.css'

const EMAIL_BODY_EXP = <p>Hi there!
<br /><br /> Do you mind helping me install Drift on our website, [your Company Url will appear here]? I asked Drift to send you this email with some instructions below - it shouldn't take more than 2 minutes. Thank you! <br /><br />[Drift code will appear here]</p>
const ERROR_MESSAGE = "Uh oh! Something went wrong when we tried to send the email. Try again!"

class EmailSnippetModal extends Component {

  static propTypes = {
    onClose: PropTypes.func.isRequired,
  }

  state = {
    email: '',
    showErrorNotification: false,
    isValid: false,
    loading: false,
  }

  onSubmit = e => {
    this.setState({ loading: true })
    e.preventDefault()
    const { email } = this.state
    track('Onboarding Install Assistance Request Email Sent', {
      context: 'widget-onboarding'
    })
    api.shareEmailSnippetExp(email)
    .then(this.onShareSnippetSuccess)
    .catch(() => this.onShareSnippetError())
  }

  onEmailChanged = (event) => {
    const changedValue = pathOr('', ['target', 'value'], event)
    const isValid = changedValue && isEmail(changedValue)
    this.setState({ email: changedValue, isValid })
  }

  onShareSnippetSuccess = () => {
    this.setState({ showErrorNotification: false })
    if (!this.props.onSuccess) {
      this.props.actions.updateOrgProperties({ properties: { signUpDone: true }, redirect: true })
    } else {
      this.props.onSuccess()
    }
  }

  onShareSnippetError = () => {
    this.setState({ showErrorNotification: true })
  }

  render() {
    const { onClose } = this.props
    const { email, showErrorNotification, isValid, loading } = this.state
    return (
      <div className="touchless-email-invite-modal-wrapper">
        <Modal open={true} onClose={onClose} className="touchless-email-invite-modal" size="small">
          <div className="touchless-email-invite-header">Email a teammate</div>
          <Form onSubmit={this.onSubmit}>
            <Input
              label="Send to"
              type="email"
              value={email}
              placeholder="Enter a teammate's email address"
              onChange={this.onEmailChanged}
              className="touchless-email-invite-email-input"
            >
            </Input>
            <div className="touchless-email-invite-message-body-label">Message</div>
            <div className="touchless-email-invite-message-body">{EMAIL_BODY_EXP}</div>
            <InstallNotification
              errorText={ERROR_MESSAGE}
              isError={showErrorNotification}
            />
            <Button submit
              disabled={!isValid}
              onClick={this.onSubmit}
              loading={loading}
              type='primary'
              className="touchless-email-invite-submit-button"
            >
              Send Message
            </Button>
          </Form>
        </Modal>
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    updateOrgProperties: OrgActions.updateOrgProperties
  }, dispatch),
})

export default connect(undefined, mapDispatchToProps)(EmailSnippetModal)



// WEBPACK FOOTER //
// ./src/layouts/InstallStep/EmailModal/index.js